<template>
  <div class="d-flex flex-wrap multiple-selector-selection">
    <div v-for="(item, index) in items" :key="item.id">
      <v-chip
        v-if="item && index < maxItemsToShow"
        class="me-2 mb-1"
        close
        small
        outlined
        pill
        color="blue-grey"
        :ripple="false"
        @click:close="$emit('remove', item)"
      >
        <span class="blue-grey--text text--darken-3">
          {{ getItemTitle(item) }}
        </span>
      </v-chip>

      <v-menu
        v-if="moreItemsSelected && index === maxItemsToShow"
        open-on-hover
        nudge-bottom="32"
        max-height="270"
      >
        <template v-slot:activator="{ on }">
          <v-chip v-on="on" small pill outlined color="blue-grey">
            <span class="blue-grey--text text--darken-3">
              +{{ moreItemsSelected }}
            </span>
          </v-chip>
        </template>

        <v-card class="ma-0 pa-0 px-4 pt-4 pb-1" dense elevation="1">
          <p
            v-for="(item, index) in items.slice(maxItemsToShow, items.length)"
            class="ma-0 pa-0 label mb-3 blue-grey--text text--darken-2 font-weight-400"
            :key="`${item}${index}`"
          >
            {{ item.title }}
          </p>
        </v-card>
      </v-menu>
    </div>

    <div
      v-if="loading && !items.length"
      class="d-flex align-center flex-grow-1 selection-skeletons"
    >
      <v-skeleton-loader class="selection-chip chip-over-chip" type="chip" />
      <v-skeleton-loader class="selection-chip chip-over-chip" type="chip" />
      <v-skeleton-loader class="selection-chip chip-over-chip" type="chip" />
      <v-skeleton-loader class="selection-chip chip-over-chip" type="chip" />
      <v-skeleton-loader class="selection-chip chip-over-chip" type="chip" />
      <v-skeleton-loader class="selection-chip chip-over-chip" type="chip" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Selection',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    maxItemsToShow: {
      type: Number,
      default: 15,
    },
    loading: Boolean,
  },

  computed: {
    moreItemsSelected() {
      const moreItems = this.items.length - this.maxItemsToShow
      return moreItems > 0 ? moreItems : null
    },
  },

  methods: {
    getItemTitle(item) {
      return item.title ?? item.name
    },
  },
}
</script>

<style scoped lang="scss">
.selection-chip .v-skeleton-loader__chip {
  height: 32px !important;
  width: 32px !important;
}
.selection-skeletons .v-skeleton-loader .v-skeleton-loader__bone {
  background: $color-blue-grey-lighten2 !important;
}
</style>
<style lang="scss">
.multiple-selector-selection {
  .v-chip.v-chip--outlined.v-chip.v-chip {
    border-color: $color-blue-grey-lighten3 !important;
  }
}
</style>
